// extracted by mini-css-extract-plugin
export default {"root":"nGTBlSJ3UlcwQ2mGXvJk","root--variant-neutral":"l3AyceDisPguiwEa2awJ","root--variant-destructive":"vn7XdgY9PS1TBPaijlzl","root--variant-action":"eywxMoAxB2tv3blSTcBv"};